<script lang="ts">
  // lib
  import { createEventDispatcher } from "svelte";
  import Flash from "@shared/services/flashv2";

  // components
  import Modal from "@shared/svelte/Components/Modal.svelte";
  import Icon from "@shared/svelte/Components/Icon.svelte";

  // types
  import type { SavedProductType } from "@shared/types/SavedProducts";
  import type { CartProduct } from "@shared/types/ProductLine";

  // props
  export let cartProduct: SavedProductType | CartProduct;
  export let show: boolean = false;
  export let location: "saved for later" | "cart";

  // data
  let submitting: boolean = false;
  const dispatch = createEventDispatcher();
  let yourLocationText = location == "cart" ? "your cart" : location;

  // functions
  const close = () => (show = false);
  const handleRemoveItem = () => {
    submitting = true;
    dispatch("delete");
    Flash.now({
      message: `<p style="display:inline" class="fizz-text-strong">${productName}</p>	
            <p style="display:inline"> was removed from ${yourLocationText}</p>`,
      type: "success",
      rawHtml: true,
    });
    show = false;
  };

  $: productName = cartProduct.product.name;
</script>

<Modal bind:show fizzModal={true} size={"medium"}>
  <div class="layout-header-footer fizz-text-left">
    <header class="fizz-modal-header">
      <h4 class="fizz-heading-4">Remove item from {location}?</h4>
      <span
        class="fizz-modal-toggle fizz-modal-close cursor-pointer"
        on:click={close}
        on:keypress={close}
      >
        <Icon height={"1rem"} type={"X"} width={"1rem"} />
      </span>
    </header>
    <section class="fizz-modal-main fizz-text-medium fizz-flow-16" data-grid-area="main">
      <p>
        Are you sure you want to remove <strong>{productName}</strong> from {yourLocationText}?
      </p>
    </section>
    <footer class="fizz-modal-footer fizz-flex-row">
      <div class="fizz-flex-row-8 fizz-full-width fizz-justify-end">
        <button class="fizz-button fizz-button" on:click={close}>Cancel</button>
        <button
          class="fizz-button-secondary fizz-button"
          disabled={submitting}
          on:click={handleRemoveItem}>Remove Item</button
        >
      </div>
    </footer>
  </div>
</Modal>
